/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbProfessionFormateurDto } from './FcbProfessionFormateurDto';
import {
    FcbProfessionFormateurDtoFromJSON,
    FcbProfessionFormateurDtoFromJSONTyped,
    FcbProfessionFormateurDtoToJSON,
} from './FcbProfessionFormateurDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbProfessionFormateurDtoPaginatedResults
 */
export interface FcbProfessionFormateurDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbProfessionFormateurDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbProfessionFormateurDto>}
     * @memberof FcbProfessionFormateurDtoPaginatedResults
     */
    results?: Array<FcbProfessionFormateurDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbProfessionFormateurDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbProfessionFormateurDtoPaginatedResults interface.
 */
export function instanceOfFcbProfessionFormateurDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbProfessionFormateurDtoPaginatedResultsFromJSON(json: any): FcbProfessionFormateurDtoPaginatedResults {
    return FcbProfessionFormateurDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbProfessionFormateurDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbProfessionFormateurDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbProfessionFormateurDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbProfessionFormateurDtoPaginatedResultsToJSON(value?: FcbProfessionFormateurDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbProfessionFormateurDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

